import React from 'react';
import { useStateValue } from "./Stateprovider";
import "./Checkout.css"
import CheckoutProduct from './CheckoutProduct';
import Subtotal from "./Subtotal";

function Checkout() {
    //const [{ basket }, dispatch] = useStateValue();
    const [{ basket }] = useStateValue();
    return (
        <div className="checkout">
        <div className ="checkout__left">

            {basket?.length === 0 ? (
                <div>
                    <h2> Your Shopping Basket is Empty</h2>
                    <p>You have no items in youir basket. To buy one or more items click "Add to basket</p>
										<br />
										<br />
                </div>
            ) : 
            (
                <div >
										<br />
										<br />
                    <h2 className="checkout__title">Your Shopping Basket</h2>

                    {/* List out all of the Checkout Products */}
                    {basket.map(item => (
                       <CheckoutProduct 
                           id={item.id}
                           title={item.title}
                           image={item.image}
                           price={item.price}
                       /> 
                    ))}
                </div>
                
            
                )}
            </div>
        </div>
    );
}

export default Checkout
